$('.featured-project-container').hover(
  function(){
    $(this).find('> a > p.featured-project-title').fadeIn(500);
    },
  function(){
    $(this).find('> a > p.featured-project-title').fadeOut(500);
  }
);

$('.similar-project-container').hover(
  function(){
    $(this).find('> a > p.similar-project-title').fadeIn(500);
    },
  function(){
    $(this).find('> a > p.similar-project-title').fadeOut(500);
  }
);

$('.masonry-brick').hover(
  function(){
    $(this).find('> p.post-title').fadeIn(500);
    },
  function(){
    $(this).find('> p.post-title').fadeOut(500);
  }
);



// WEBPACK FOOTER //
// ./scripts/titleFade.js